import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from '../components/header/header.component';
import { SidebarComponent } from '../components/sidebar/sidebar.component';
import { FooterComponent } from '../components/footer/footer.component';
import { SidebarService } from '../services/sidebar.service';
import { LanguageService } from '../services/language.service';

@Component({
  selector: 'app-manual-layout',
  imports: [RouterOutlet, HeaderComponent, SidebarComponent, FooterComponent],
  templateUrl: './manual-layout.html',
  styleUrl: './manual-layout.scss',
})
export class ManualLayout {
  readonly sidebarService = inject(SidebarService);
  // Instancie LanguageService dans l'injecteur de ce sous-arbre (voir manual.routes.ts),
  // pour qu'il reçoive bien le TranslateService scopé au manuel, pas celui du reste du site.
  private readonly languageService = inject(LanguageService);
}
